import { render, staticRenderFns } from "./ImageManagement.vue?vue&type=template&id=2f7e2e1c&scoped=true"
import script from "./ImageManagement.vue?vue&type=script&lang=js"
export * from "./ImageManagement.vue?vue&type=script&lang=js"
import style0 from "./ImageManagement.vue?vue&type=style&index=0&id=2f7e2e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e2e1c",
  null
  
)

export default component.exports